import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import LoaderOverlay from "app/containers/OnBoarding/containers/Team/components/LoaderOverlay";
import { selectIsLoading } from "app/containers/OnBoarding/redux/selector";
import TitleText from "../../components/TitleText";
import SignupForm from "./SignupForm";
import FooterLinks from "./FooterLinks";
import useInviteHandler from "./useInviteHandler";

export default function Signup() {
  const [isEmail, setIsEmail] = useState(false);
  const inviteLoading = useSelector(selectIsLoading);
  const [searchParams] = useSearchParams();

  // 🔹 Handles invite verification + clears token
  useInviteHandler(setIsEmail, searchParams);

  return (
    <div className="flex flex-col items-center">
      {inviteLoading && <LoaderOverlay />}
      <TitleText title=" Sign up to Teambox.Dev" />

      <SignupForm isEmail={isEmail} setIsEmail={setIsEmail} searchParams={ searchParams.get("token") as string} />
      <FooterLinks />
    </div>
  );
}
